import axios from "axios";

export default {
  updateState: (id, state) => axios.put(`/api/embroidery/${id}`, state),
  embroideryReport: (params, cancelToken) =>
    axios.get(`/api/embroidery/export/all`, { cancelToken, params, responseType: "blob" }),
};
